import Model from "../Model";

export interface TApplicantReportingPeriod {
  id: number;
  applicantId: number;
  applicantReportingPeriodId: number;
  reportingPeriodId: number;
  fromPeriod: Date;
  toPeriod?: Date;
  isEvaluationCandidate?: boolean;
  reportingPeriodName: string;
  reportingTypeName: string;
  hasRightOfEntry?: boolean;
  hasRightOfPreview?: boolean;
  evaluationReason: string;
  evaluationStatus: string;
  evaluationDate: Date;
}

export interface IApplicantReportingPeriod extends TApplicantReportingPeriod {}

const ApplicantReportingPeriod = Model(
  (model: TApplicantReportingPeriod): IApplicantReportingPeriod => {
    const _applicantReportingPeriod: TApplicantReportingPeriod = Object.assign(
      {},
      model
    );

    return {
      get id() {
        return _applicantReportingPeriod.id;
      },

      get applicantId() {
        return _applicantReportingPeriod.applicantId;
      },

      get applicantReportingPeriodId() {
        return _applicantReportingPeriod.applicantReportingPeriodId;
      },

      get fromPeriod() {
        return _applicantReportingPeriod.fromPeriod;
      },
      get toPeriod() {
        return _applicantReportingPeriod.toPeriod;
      },

      set applicantId(value: any) {
        _applicantReportingPeriod.applicantId = value;
      },

      set applicantReportingPeriodId(value: any) {
        _applicantReportingPeriod.applicantReportingPeriodId = value;
      },

      set fromPeriod(value: any) {
        _applicantReportingPeriod.fromPeriod = value;
      },

      set toPeriod(value: any) {
        _applicantReportingPeriod.toPeriod = value;
      },
      get isEvaluationCandidate() {
        return _applicantReportingPeriod.isEvaluationCandidate;
      },

      set isEvaluationCandidate(value: any) {
        _applicantReportingPeriod.isEvaluationCandidate = value;
      },
      get reportingPeriodName() {
        return _applicantReportingPeriod.reportingPeriodName;
      },

      set reportingPeriodName(value: any) {
        _applicantReportingPeriod.reportingPeriodName = value;
      },
      get reportingTypeName() {
        return _applicantReportingPeriod.reportingTypeName;
      },

      set reportingTypeName(value: any) {
        _applicantReportingPeriod.reportingTypeName = value;
      },
      get reportingPeriodId() {
        return _applicantReportingPeriod.reportingPeriodId;
      },

      set reportingPeriodId(value: any) {
        _applicantReportingPeriod.reportingPeriodId = value;
      },

      get hasRightOfEntry() {
        return _applicantReportingPeriod.hasRightOfEntry;
      },

      set hasRightOfEntry(value: any) {
        _applicantReportingPeriod.hasRightOfEntry = value;
      },

      get hasRightOfPreview() {
        return _applicantReportingPeriod.hasRightOfPreview;
      },

      set hasRightOfPreview(value: any) {
        _applicantReportingPeriod.hasRightOfPreview = value;
      },
      get evaluationReason() {
        return _applicantReportingPeriod.evaluationReason;
      },
      set evaluationReason(value) {
        _applicantReportingPeriod.evaluationReason = value;
      },
      get evaluationStatus() {
        return _applicantReportingPeriod.evaluationStatus;
      },
      set evaluationStatus(value) {
        _applicantReportingPeriod.evaluationStatus = value;
      },
      get evaluationDate() {
        return _applicantReportingPeriod.evaluationDate;
      },
      set evaluationDate(value) {
        _applicantReportingPeriod.evaluationDate = value;
      }
    };
  }
);

export default ApplicantReportingPeriod;
